import React from 'react';

interface LoadingIndicatorProps {
  message?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ message = 'Lädt...' }) => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        {/* Beer Glass Container */}
        <div className="relative w-24 h-32 mx-auto mb-4">
          {/* Glass Shine Effect */}
          <div className="absolute top-0 left-1/4 w-1 h-full bg-white/20 transform -skew-x-12 z-20" />
          <div className="absolute top-0 left-1/3 w-px h-full bg-white/10 transform -skew-x-12 z-20" />
          
          {/* Glass Handle */}
          <div className="absolute -left-6 top-1/2 -translate-y-1/2 w-6 h-12 border-4 border-gray-300/80 rounded-l-full">
            {/* Handle Shine */}
            <div className="absolute top-0 left-1/2 w-px h-full bg-white/20" />
          </div>
          
          {/* Main Glass */}
          <div className="absolute inset-0 border-4 border-gray-300/80 rounded-b-lg bg-gray-50/10 backdrop-blur-sm">
            {/* Beer Foam */}
            <div className="absolute top-0 left-0 right-0 h-8 bg-gradient-to-b from-white to-amber-100 rounded-t-lg animate-pulse">
              {/* Foam Bubbles */}
              <div className="absolute bottom-0 left-2 w-2 h-2 bg-white rounded-full" />
              <div className="absolute bottom-1 left-6 w-3 h-3 bg-white rounded-full" />
              <div className="absolute bottom-2 right-3 w-2 h-2 bg-white rounded-full" />
            </div>
            
            {/* Beer Liquid */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 rounded-b-lg animate-[wave_2s_ease-in-out_infinite]" style={{
              height: '0%',
              animation: 'fill 2s ease-in-out infinite'
            }}>
              {/* Bubbles */}
              <div className="absolute inset-0">
                <div className="absolute left-2 bottom-4 w-1 h-1 bg-white/40 rounded-full animate-[bubble_1.5s_ease-in-out_infinite]" />
                <div className="absolute left-6 bottom-8 w-1.5 h-1.5 bg-white/40 rounded-full animate-[bubble_2s_ease-in-out_infinite_0.5s]" />
                <div className="absolute right-3 bottom-6 w-1 h-1 bg-white/40 rounded-full animate-[bubble_1.8s_ease-in-out_infinite_0.3s]" />
              </div>
            </div>
          </div>
        </div>
        <p className="text-gray-600 animate-pulse">{message}</p>
      </div>

      {/* Add keyframe animations */}
      <style>
        {`
          @keyframes fill {
            0%, 100% {
              height: 0%;
              background-position: 0% 50%;
            }
            50% {
              height: 85%;
              background-position: 100% 50%;
            }
          }

          @keyframes wave {
            0%, 100% {
              transform: translateY(0) scaleY(1);
            }
            50% {
              transform: translateY(-5px) scaleY(1.02);
            }
          }

          @keyframes bubble {
            0% {
              transform: translateY(0) scale(1);
              opacity: 0;
            }
            50% {
              transform: translateY(-20px) scale(1.2);
              opacity: 1;
            }
            100% {
              transform: translateY(-40px) scale(1);
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingIndicator;